.responsive2284599289__root {
    -st-states: darkMode;
}

/* st-namespace-reference="../../../../src/utils/skins/responsive.st.css" */